var _class, _descriptor;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.reverse.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { makeObservable, observable } from "mobx";
import Ellipsoid from "terriajs-cesium/Source/Core/Ellipsoid";
import ConstantPositionProperty from "terriajs-cesium/Source/DataSources/ConstantPositionProperty";
import Entity from "terriajs-cesium/Source/DataSources/Entity";
const customProperties = ["entityCollection", "properties", "data"];

/** Terria wrapper around Cesium Entity
 * Adds a few extra properties
 * -
 */
let TerriaFeature = (_class = class TerriaFeature extends Entity {
  constructor(options) {
    super(options);
    /** This object can be used to pass Terria-specific properties */
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "cesiumEntity", void 0);
    _defineProperty(this, "imageryLayer", void 0);
    /** This comes from Cesium.scene.drillPick
     * No type provided
     */
    _defineProperty(this, "cesiumPrimitive", void 0);
    _defineProperty(this, "_catalogItem", void 0);
    _defineProperty(this, "_cesium3DTileFeature", void 0);
    /** Flag if loading featureInfoUrl (see `FeatureInfoUrlTemplateMixin.getFeaturesFromPickResult`) */
    _initializerDefineProperty(this, "loadingFeatureInfoUrl", _descriptor, this);
    makeObservable(this);
    addCustomFeatureProperties(this);
  }

  /**
   * Creates a new Feature from an Entity.
   * Note the custom properties are also copied into the new Feature properly.
   */
  static fromEntity(entity) {
    const feature = new TerriaFeature({
      id: entity.id
    });
    feature.merge(entity);
    for (let i = 0; i < customProperties.length; i++) {
      if (entity.propertyNames.indexOf(customProperties[i]) === -1) {
        feature[customProperties[i]] = entity[customProperties[i]]; // Assume no merging or cloning needed.
      }
    }
    feature.cesiumEntity = entity;
    return feature;
  }

  /**
   * If the given entity is part of an entityCollection, and those entities are themselves features,
   * then return the matching feature from the collection.
   * Otherwise, return a new Feature from this entity.
   */
  static fromEntityCollectionOrEntity(entity) {
    // If this entity is part of a collection, get the feature with this id from that collection.
    let feature;
    if (entity.entityCollection) {
      feature = entity.entityCollection.getById(entity.id);
    }
    if (!feature || !(feature instanceof TerriaFeature)) {
      feature = TerriaFeature.fromEntity(entity);
    }
    return feature;
  }
  static fromImageryLayerFeatureInfo(imageryFeature) {
    const feature = new TerriaFeature({
      id: imageryFeature.name,
      name: imageryFeature.name,
      description: imageryFeature.description,
      properties: imageryFeature.properties
    });
    feature.data = imageryFeature.data;
    feature.imageryLayer = imageryFeature.imageryLayer;
    if (imageryFeature.position) {
      feature.position = new ConstantPositionProperty(Ellipsoid.WGS84.cartographicToCartesian(imageryFeature.position));
    }
    return feature;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "loadingFeatureInfoUrl", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { TerriaFeature as default }; // Features have 'entityCollection', 'properties' and 'data' properties, which we must add to the entity's property list,
// if they're not already there. (In case they are added in a future version of Cesium.)
function addCustomFeatureProperties(entity) {
  for (let i = 0; i < customProperties.length; i++) {
    const propertyName = customProperties[i];
    if (entity.propertyNames.indexOf(propertyName) === -1 && !(propertyName in entity)) {
      entity.addProperty(customProperties[i]);
    }
  }
}